<div class="grow overflow-y-auto">
    <valben-table
        [loading]="loading()"
        entityType="Benefit"
        [columns]="cols"
        [values]="tableValues()"
        [refresh]="refresh"
        [lazy]="true"
        [totalRecords]="totalRecords()"
        (lazyLoad)="loadPage($event)"
        (editEvent)="edit($event)"
        [addLabel]="'Dodaj benefit'"
        (addEvent)="add()"
    >
    </valben-table>
</div>
